//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql.adapter

import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.AnyAdapter
import com.apollographql.apollo.api.BooleanAdapter
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.IntAdapter
import com.apollographql.apollo.api.NullableAnyAdapter
import com.apollographql.apollo.api.NullableIntAdapter
import com.apollographql.apollo.api.NullableStringAdapter
import com.apollographql.apollo.api.StringAdapter
import com.apollographql.apollo.api.json.JsonReader
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.list
import com.apollographql.apollo.api.missingField
import com.apollographql.apollo.api.nullable
import com.apollographql.apollo.api.obj
import com.wintermar.inspection.graphql.InspectionTemplatesQuery
import com.wintermar.inspection.graphql.type.InspectionAnswerType
import com.wintermar.inspection.graphql.type.InspectionTemplateStatus
import com.wintermar.inspection.graphql.type.adapter.InspectionAnswerType_ResponseAdapter
import com.wintermar.inspection.graphql.type.adapter.InspectionTemplateStatus_ResponseAdapter
import kotlin.Any
import kotlin.Boolean
import kotlin.Int
import kotlin.String
import kotlin.collections.List

public object InspectionTemplatesQuery_ResponseAdapter {
  public object Data : Adapter<InspectionTemplatesQuery.Data> {
    public val RESPONSE_NAMES: List<String> = listOf("inspectionTemplates")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): InspectionTemplatesQuery.Data {
      var _inspectionTemplates: InspectionTemplatesQuery.InspectionTemplates? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _inspectionTemplates = InspectionTemplates.obj().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return InspectionTemplatesQuery.Data(
        inspectionTemplates = _inspectionTemplates ?: missingField(reader, "inspectionTemplates")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: InspectionTemplatesQuery.Data,
    ) {
      writer.name("inspectionTemplates")
      InspectionTemplates.obj().toJson(writer, customScalarAdapters, value.inspectionTemplates)
    }
  }

  public object InspectionTemplates : Adapter<InspectionTemplatesQuery.InspectionTemplates> {
    public val RESPONSE_NAMES: List<String> = listOf("data", "totalCount")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): InspectionTemplatesQuery.InspectionTemplates {
      var _data: List<InspectionTemplatesQuery.Data1>? = null
      var _totalCount: Int? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _data = Data1.obj().list().nullable().fromJson(reader, customScalarAdapters)
          1 -> _totalCount = IntAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return InspectionTemplatesQuery.InspectionTemplates(
        `data` = _data,
        totalCount = _totalCount ?: missingField(reader, "totalCount")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: InspectionTemplatesQuery.InspectionTemplates,
    ) {
      writer.name("data")
      Data1.obj().list().nullable().toJson(writer, customScalarAdapters, value.`data`)

      writer.name("totalCount")
      IntAdapter.toJson(writer, customScalarAdapters, value.totalCount)
    }
  }

  public object Data1 : Adapter<InspectionTemplatesQuery.Data1> {
    public val RESPONSE_NAMES: List<String> =
        listOf("id", "name", "status", "version", "publishedDate", "parentId", "numberOfPages", "numberOfSections", "numberOfQuestions", "pages")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): InspectionTemplatesQuery.Data1 {
      var _id: Any? = null
      var _name: String? = null
      var _status: InspectionTemplateStatus? = null
      var _version: Int? = null
      var _publishedDate: Any? = null
      var _parentId: Any? = null
      var _numberOfPages: Int? = null
      var _numberOfSections: Int? = null
      var _numberOfQuestions: Int? = null
      var _pages: List<InspectionTemplatesQuery.Page>? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _id = AnyAdapter.fromJson(reader, customScalarAdapters)
          1 -> _name = StringAdapter.fromJson(reader, customScalarAdapters)
          2 -> _status = InspectionTemplateStatus_ResponseAdapter.fromJson(reader, customScalarAdapters)
          3 -> _version = IntAdapter.fromJson(reader, customScalarAdapters)
          4 -> _publishedDate = NullableAnyAdapter.fromJson(reader, customScalarAdapters)
          5 -> _parentId = NullableAnyAdapter.fromJson(reader, customScalarAdapters)
          6 -> _numberOfPages = NullableIntAdapter.fromJson(reader, customScalarAdapters)
          7 -> _numberOfSections = NullableIntAdapter.fromJson(reader, customScalarAdapters)
          8 -> _numberOfQuestions = NullableIntAdapter.fromJson(reader, customScalarAdapters)
          9 -> _pages = Page.obj().list().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return InspectionTemplatesQuery.Data1(
        id = _id ?: missingField(reader, "id"),
        name = _name ?: missingField(reader, "name"),
        status = _status ?: missingField(reader, "status"),
        version = _version ?: missingField(reader, "version"),
        publishedDate = _publishedDate,
        parentId = _parentId,
        numberOfPages = _numberOfPages,
        numberOfSections = _numberOfSections,
        numberOfQuestions = _numberOfQuestions,
        pages = _pages ?: missingField(reader, "pages")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: InspectionTemplatesQuery.Data1,
    ) {
      writer.name("id")
      AnyAdapter.toJson(writer, customScalarAdapters, value.id)

      writer.name("name")
      StringAdapter.toJson(writer, customScalarAdapters, value.name)

      writer.name("status")
      InspectionTemplateStatus_ResponseAdapter.toJson(writer, customScalarAdapters, value.status)

      writer.name("version")
      IntAdapter.toJson(writer, customScalarAdapters, value.version)

      writer.name("publishedDate")
      NullableAnyAdapter.toJson(writer, customScalarAdapters, value.publishedDate)

      writer.name("parentId")
      NullableAnyAdapter.toJson(writer, customScalarAdapters, value.parentId)

      writer.name("numberOfPages")
      NullableIntAdapter.toJson(writer, customScalarAdapters, value.numberOfPages)

      writer.name("numberOfSections")
      NullableIntAdapter.toJson(writer, customScalarAdapters, value.numberOfSections)

      writer.name("numberOfQuestions")
      NullableIntAdapter.toJson(writer, customScalarAdapters, value.numberOfQuestions)

      writer.name("pages")
      Page.obj().list().toJson(writer, customScalarAdapters, value.pages)
    }
  }

  public object Page : Adapter<InspectionTemplatesQuery.Page> {
    public val RESPONSE_NAMES: List<String> =
        listOf("id", "templateId", "order", "title", "sections")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): InspectionTemplatesQuery.Page {
      var _id: Any? = null
      var _templateId: Any? = null
      var _order: Int? = null
      var _title: String? = null
      var _sections: List<InspectionTemplatesQuery.Section>? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _id = AnyAdapter.fromJson(reader, customScalarAdapters)
          1 -> _templateId = AnyAdapter.fromJson(reader, customScalarAdapters)
          2 -> _order = IntAdapter.fromJson(reader, customScalarAdapters)
          3 -> _title = StringAdapter.fromJson(reader, customScalarAdapters)
          4 -> _sections = Section.obj().list().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return InspectionTemplatesQuery.Page(
        id = _id ?: missingField(reader, "id"),
        templateId = _templateId ?: missingField(reader, "templateId"),
        order = _order ?: missingField(reader, "order"),
        title = _title ?: missingField(reader, "title"),
        sections = _sections ?: missingField(reader, "sections")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: InspectionTemplatesQuery.Page,
    ) {
      writer.name("id")
      AnyAdapter.toJson(writer, customScalarAdapters, value.id)

      writer.name("templateId")
      AnyAdapter.toJson(writer, customScalarAdapters, value.templateId)

      writer.name("order")
      IntAdapter.toJson(writer, customScalarAdapters, value.order)

      writer.name("title")
      StringAdapter.toJson(writer, customScalarAdapters, value.title)

      writer.name("sections")
      Section.obj().list().toJson(writer, customScalarAdapters, value.sections)
    }
  }

  public object Section : Adapter<InspectionTemplatesQuery.Section> {
    public val RESPONSE_NAMES: List<String> = listOf("id", "pageId", "order", "title", "questions")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): InspectionTemplatesQuery.Section {
      var _id: Any? = null
      var _pageId: Any? = null
      var _order: Int? = null
      var _title: String? = null
      var _questions: List<InspectionTemplatesQuery.Question>? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _id = AnyAdapter.fromJson(reader, customScalarAdapters)
          1 -> _pageId = AnyAdapter.fromJson(reader, customScalarAdapters)
          2 -> _order = IntAdapter.fromJson(reader, customScalarAdapters)
          3 -> _title = StringAdapter.fromJson(reader, customScalarAdapters)
          4 -> _questions = Question.obj().list().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return InspectionTemplatesQuery.Section(
        id = _id ?: missingField(reader, "id"),
        pageId = _pageId ?: missingField(reader, "pageId"),
        order = _order ?: missingField(reader, "order"),
        title = _title ?: missingField(reader, "title"),
        questions = _questions ?: missingField(reader, "questions")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: InspectionTemplatesQuery.Section,
    ) {
      writer.name("id")
      AnyAdapter.toJson(writer, customScalarAdapters, value.id)

      writer.name("pageId")
      AnyAdapter.toJson(writer, customScalarAdapters, value.pageId)

      writer.name("order")
      IntAdapter.toJson(writer, customScalarAdapters, value.order)

      writer.name("title")
      StringAdapter.toJson(writer, customScalarAdapters, value.title)

      writer.name("questions")
      Question.obj().list().toJson(writer, customScalarAdapters, value.questions)
    }
  }

  public object Question : Adapter<InspectionTemplatesQuery.Question> {
    public val RESPONSE_NAMES: List<String> =
        listOf("id", "sectionId", "questionText", "guidelines", "required", "order", "answerType", "failedOptionId", "neutralOptionId")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): InspectionTemplatesQuery.Question {
      var _id: Any? = null
      var _sectionId: Any? = null
      var _questionText: String? = null
      var _guidelines: String? = null
      var _required: Boolean? = null
      var _order: Int? = null
      var _answerType: InspectionAnswerType? = null
      var _failedOptionId: Any? = null
      var _neutralOptionId: Any? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _id = AnyAdapter.fromJson(reader, customScalarAdapters)
          1 -> _sectionId = AnyAdapter.fromJson(reader, customScalarAdapters)
          2 -> _questionText = StringAdapter.fromJson(reader, customScalarAdapters)
          3 -> _guidelines = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          4 -> _required = BooleanAdapter.fromJson(reader, customScalarAdapters)
          5 -> _order = IntAdapter.fromJson(reader, customScalarAdapters)
          6 -> _answerType = InspectionAnswerType_ResponseAdapter.fromJson(reader, customScalarAdapters)
          7 -> _failedOptionId = NullableAnyAdapter.fromJson(reader, customScalarAdapters)
          8 -> _neutralOptionId = NullableAnyAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return InspectionTemplatesQuery.Question(
        id = _id ?: missingField(reader, "id"),
        sectionId = _sectionId ?: missingField(reader, "sectionId"),
        questionText = _questionText ?: missingField(reader, "questionText"),
        guidelines = _guidelines,
        required = _required ?: missingField(reader, "required"),
        order = _order ?: missingField(reader, "order"),
        answerType = _answerType ?: missingField(reader, "answerType"),
        failedOptionId = _failedOptionId,
        neutralOptionId = _neutralOptionId
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: InspectionTemplatesQuery.Question,
    ) {
      writer.name("id")
      AnyAdapter.toJson(writer, customScalarAdapters, value.id)

      writer.name("sectionId")
      AnyAdapter.toJson(writer, customScalarAdapters, value.sectionId)

      writer.name("questionText")
      StringAdapter.toJson(writer, customScalarAdapters, value.questionText)

      writer.name("guidelines")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.guidelines)

      writer.name("required")
      BooleanAdapter.toJson(writer, customScalarAdapters, value.required)

      writer.name("order")
      IntAdapter.toJson(writer, customScalarAdapters, value.order)

      writer.name("answerType")
      InspectionAnswerType_ResponseAdapter.toJson(writer, customScalarAdapters, value.answerType)

      writer.name("failedOptionId")
      NullableAnyAdapter.toJson(writer, customScalarAdapters, value.failedOptionId)

      writer.name("neutralOptionId")
      NullableAnyAdapter.toJson(writer, customScalarAdapters, value.neutralOptionId)
    }
  }
}
